/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createPow } from '../../factoriesNumber.js';
export var powDependencies = {
  typedDependencies,
  createPow
};